import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  AfterViewInit,
  Input,
} from '@angular/core';

@Directive({
  selector: '[rdoFillRemainingHeight]',
  standalone: true,
})
export class FillRemainingHeightDirective implements AfterViewInit {
  // Optional: Allow the user to subtract extra space (e.g., for a bottom footer)
  @Input() bottomOffset: number = 0;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  // We use AfterViewInit to ensure the element is in the DOM and positioned correctly
  ngAfterViewInit() {
    console.log('fill-remaining-height.directive.ngAfterViewInit  called');
    this.calculateHeight();
    // Optional: Recalculate after a slight delay in case layouts shift initially
    setTimeout(() => this.calculateHeight(), 0);
  }

  // Listen for window resize events to adjust height dynamically
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.calculateHeight();
  }

  private calculateHeight() {
    // 1. Get the window height
    const windowHeight = window.innerHeight;

    // 2. Get the element's current position relative to the viewport
    const elementTop = this.el.nativeElement.getBoundingClientRect().top;

    // 3. Calculate remaining height
    // Ensure we don't return a negative number if the element is off-screen
    const height = Math.max(
      0,
      windowHeight - elementTop - this.bottomOffset - 20
    );

    // 4. Apply the style
    this.renderer.setStyle(this.el.nativeElement, 'height', `${height}px`);

    // Optional: Set overflow-y to auto if you want scrollbars when content exceeds this height
    // this.renderer.setStyle(this.el.nativeElement, 'overflow-y', 'auto');
  }
}
